/**
 * Reads the SAME `onlineManager` singleton TanStack Query uses to pause and
 * resume queries. The offline banner's visibility can never disagree with
 * what the query client is actually doing. Tests drive it with
 * `onlineManager.setOnline(boolean)`, Query's own public test hook, rather
 * than dispatching a fake browser event.
 */
import { onlineManager } from "@tanstack/react-query";
import { useSyncExternalStore } from "react";

export function useOnlineStatus(): boolean {
  return useSyncExternalStore(
    (onStoreChange) =>
      onlineManager.subscribe(() => {
        onStoreChange();
      }),
    () => onlineManager.isOnline(),
    () => true,
  );
}
